<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button-group>
        <el-button type="primary" size="small" @click="handleCellBatchProcessing('DOOR_OPEN')" :disabled="cellNos.length <= 0">批量开箱</el-button>
        <el-button type="warning" size="small" @click="handleCellBatchProcessing('LIGHT_OPEN')" :disabled="cellNos.length <= 0">批量开灯</el-button>
        <el-button type="warning" size="small" @click="handleCellBatchProcessing('LIGHT_CLOSE')" :disabled="cellNos.length <= 0">批量关灯</el-button>
        <el-button type="success" size="small" @click="handleCellBatchProcessing('WARM_START')" :disabled="cellNos.length <= 0">批量加热</el-button>
        <el-button type="success" size="small" @click="handleCellBatchProcessing('WARM_STOP')" :disabled="cellNos.length <= 0">批量停止加热</el-button>
        <el-button type="info" size="small" @click="handleCellBatchProcessing('DISINFECT_START')" :disabled="cellNos.length <= 0">批量消毒</el-button>
        <el-button type="info" size="small" @click="handleCellBatchProcessing('DISINFECT_STOP')" :disabled="cellNos.length <= 0">批量停止消毒</el-button>
      </el-button-group>
    </div>

    <el-table v-loading="listLoading" :data="list" @selection-change="handleSelectionChange" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column type="selection" align="center" width="45"></el-table-column>

      <el-table-column label="设备ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.deviceId }}
        </template>
      </el-table-column>

      <el-table-column label="格子编号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.cellNo }}
        </template>
      </el-table-column>

      <el-table-column label="门的状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="getJsonObject(scope.row.cellInfo).door === 'opening'" type="success">开启</el-tag>
          <el-tag v-else-if="getJsonObject(scope.row.cellInfo).door === 'opened'" type="success">开启</el-tag>
          <el-tag v-else-if="getJsonObject(scope.row.cellInfo).door === 'closing'" type="danger">关闭</el-tag>
          <el-tag v-else-if="getJsonObject(scope.row.cellInfo).door === 'closed'" type="danger">关闭</el-tag>
          {{ getJsonObject(scope.row.cellInfo).door }}
        </template>
      </el-table-column>

      <el-table-column label="灯的状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="getJsonObject(scope.row.cellInfo).light === 'opening'" type="success">开启</el-tag>
          <el-tag v-else-if="getJsonObject(scope.row.cellInfo).light === 'opened'" type="success">开启</el-tag>
          <el-tag v-else-if="getJsonObject(scope.row.cellInfo).light === 'closing'" type="danger">关闭</el-tag>
          <el-tag v-else-if="getJsonObject(scope.row.cellInfo).light === 'closed'" type="danger">关闭</el-tag>
          {{ getJsonObject(scope.row.cellInfo).light }}
        </template>
      </el-table-column>

      <el-table-column label="加热状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="getJsonObject(scope.row.cellInfo).warm === 'opening'" type="success">开启</el-tag>
          <el-tag v-else-if="getJsonObject(scope.row.cellInfo).warm === 'opened'" type="success">开启</el-tag>
          <el-tag v-else-if="getJsonObject(scope.row.cellInfo).warm === 'closing'" type="danger">关闭</el-tag>
          <el-tag v-else-if="getJsonObject(scope.row.cellInfo).warm === 'closed'" type="danger">关闭</el-tag>
          <el-tag v-else-if="getJsonObject(scope.row.cellInfo).warm === 'starting'" type="success">开启</el-tag>
          <el-tag v-else-if="getJsonObject(scope.row.cellInfo).warm === 'started'" type="success">开启</el-tag>
          <el-tag v-else-if="getJsonObject(scope.row.cellInfo).warm === 'stopping'" type="danger">停止</el-tag>
          <el-tag v-else-if="getJsonObject(scope.row.cellInfo).warm === 'stopped'" type="danger">停止</el-tag>
          {{ getJsonObject(scope.row.cellInfo).warm }}
        </template>
      </el-table-column>

      <el-table-column label="消毒状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="getJsonObject(scope.row.cellInfo).disinfect === 'opening'" type="success">开启</el-tag>
          <el-tag v-else-if="getJsonObject(scope.row.cellInfo).disinfect === 'opened'" type="success">开启</el-tag>
          <el-tag v-else-if="getJsonObject(scope.row.cellInfo).disinfect === 'closing'" type="danger">关闭</el-tag>
          <el-tag v-else-if="getJsonObject(scope.row.cellInfo).disinfect === 'closed'" type="danger">关闭</el-tag>
          <el-tag v-else-if="getJsonObject(scope.row.cellInfo).disinfect === 'starting'" type="success">开启</el-tag>
          <el-tag v-else-if="getJsonObject(scope.row.cellInfo).disinfect === 'started'" type="success">开启</el-tag>
          <el-tag v-else-if="getJsonObject(scope.row.cellInfo).disinfect === 'stopping'" type="danger">停止</el-tag>
          <el-tag v-else-if="getJsonObject(scope.row.cellInfo).disinfect === 'stopped'" type="danger">停止</el-tag>
          {{ getJsonObject(scope.row.cellInfo).disinfect }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import request from "@/utils/request";
  import { mapGetters } from "vuex";

  export default {
    data() {
      return {
        list: null,
        listLoading: true,
        listQuery: {
          id: "",
        },
        btnLoading: false,
        // 格子批量处理
        cellNos: [],
      };
    },
    created() {
      this.listQuery.id = parseInt(this.$route.query.id || 0);
      this.getList();
    },
    computed: {
      ...mapGetters(["schools","school_id","user"])
    },
    methods: {
      getList() {
        this.listLoading = true;
        request({
          url: "/api/backend/sideboardDevice/cells",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.list = response.data.cells;
          this.listLoading = false;
        });
      },
      getJsonObject(jsonString) {
        return JSON.parse(jsonString);
      },
      // 格子批量处理
      handleSelectionChange(val) {
        let cellNos = [];
        val.forEach(element => {
          cellNos.push(element.cellNo);
        });
        this.cellNos = cellNos;
      },
      handleCellBatchProcessing(option) {
        if (this.cellNos.length <= 0) {
          this.$message({
            type: "warning",
            message: "请选择项"
          });
          return;
        }

        this.$confirm("确认继续该操作", "提示", {
          type: "warning"
        }).then(() => {
          request({
            url: "/api/backend/sideboardDevice/cellBatchProcessing",
            method: "post",
            data: {
              ids: [this.listQuery.id],
              cell_nos: this.cellNos,
              option: option,
            },
            timeout: 6000000,
          }).then(()=>{
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功"
            });
          })
        }).catch(() => {});
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
